import { FeatureIds, isCapabilityAvailable, RegistryType } from "@redbelly-tokeniser/mystake-common-sdk";

/**
 * Whether the FATCA/CRS surfaces — data-entry sections, entity classification, the contact-type
 * roles, and the export control — should be shown. Fund-only (catalog `appliesTo`); always on for a
 * fund. `features` is unused and kept so existing call sites stay unchanged.
 */
export const canShowFatcaCrs = (_features: { [key: string]: boolean }, isFundRegistry: boolean): boolean =>
  isCapabilityAvailable(FeatureIds.FATCA_CRS, isFundRegistry ? RegistryType.Fund : RegistryType.Company);
